var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "full-height" },
    [
      _vm.type === "color"
        ? [
            _c("div", { class: `banner-item card-type-${_vm.type}` }, [
              _c("div", {
                staticClass: "color-background",
                style: `background-color:${_vm.backgroundColor}`,
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "banner-content",
                  class: `banner-text-${_vm.textAlign} banner-content-position-${_vm.verticalTextAlign}`,
                },
                [
                  _c(
                    "b-container",
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("div", { staticClass: "banner-content-inner" }, [
                              _c("div", { staticClass: "banner-title" }, [
                                _c("h1", { style: `color:${_vm.textColor}` }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.title) +
                                      "\n                "
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "banner-description",
                                  style: `color:${_vm.textColor}`,
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.description) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "banner-action" },
                                [
                                  _vm.buttonPrimaryExists
                                    ? [
                                        _c(
                                          "generic-link",
                                          {
                                            staticClass:
                                              "btn banner-btn banner-btn-primary",
                                            attrs: {
                                              target: _vm.primaryButtonTarget,
                                              href: _vm.buttonPrimaryUrl,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(_vm.buttonPrimaryText) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.buttonSecondaryExists
                                    ? [
                                        _c(
                                          "generic-link",
                                          {
                                            staticClass:
                                              "btn banner-btn banner-btn-secondary",
                                            attrs: {
                                              target: _vm.secondaryButtonTarget,
                                              href: _vm.buttonSecondaryUrl,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm.buttonSecondaryText
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        : _vm.type === "photo"
        ? [
            _c(
              "div",
              { class: `banner-item card-type-${_vm.type}` },
              [
                _c(
                  "div",
                  { staticClass: "image-background" },
                  [
                    _c("AImage", {
                      attrs: {
                        img: _vm.item.fileStore,
                        title: _vm.title,
                        alt: _vm.title,
                        responsive: "",
                        preset: "carousel-image",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", {
                  staticClass: "image-overlay",
                  style: `opacity:${_vm.backgroundTinting}`,
                }),
                _vm._v(" "),
                _vm.description ||
                _vm.title ||
                _vm.buttonPrimaryExists ||
                _vm.buttonSecondaryExists
                  ? _c(
                      "div",
                      {
                        staticClass: "banner-content banner-content-gradient",
                        class: `banner-text-${_vm.textAlign} banner-content-position-${_vm.verticalTextAlign}`,
                      },
                      [
                        _c(
                          "b-container",
                          [
                            _c(
                              "b-row",
                              [
                                _c("b-col", [
                                  _c(
                                    "div",
                                    { staticClass: "banner-content-inner" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "banner-title" },
                                        [_c("h1", [_vm._v(_vm._s(_vm.title))])]
                                      ),
                                      _vm._v(" "),
                                      _vm.description
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "banner-description",
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(_vm.description) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.buttonPrimaryExists ||
                                      _vm.buttonSecondaryExists
                                        ? _c(
                                            "div",
                                            { staticClass: "banner-action" },
                                            [
                                              _vm.buttonPrimaryExists
                                                ? [
                                                    _c(
                                                      "generic-link",
                                                      {
                                                        staticClass:
                                                          "btn banner-btn banner-btn-primary",
                                                        attrs: {
                                                          target:
                                                            _vm.primaryButtonTarget,
                                                          href: _vm.buttonPrimaryUrl,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.buttonPrimaryText
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.buttonSecondaryExists
                                                ? [
                                                    _c(
                                                      "generic-link",
                                                      {
                                                        staticClass:
                                                          "btn banner-btn banner-btn-secondary",
                                                        attrs: {
                                                          target:
                                                            _vm.secondaryButtonTarget,
                                                          href: _vm.buttonSecondaryUrl,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      " +
                                                            _vm._s(
                                                              _vm.buttonSecondaryText
                                                            ) +
                                                            "\n                    "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm.buttonPrimaryUrl
                  ? [
                      _c("generic-link", {
                        staticClass: "banner-overlay-link",
                        attrs: {
                          target: _vm.primaryButtonTarget,
                          href: _vm.buttonPrimaryUrl,
                        },
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        : _vm.type === "video"
        ? [
            _c("div", { class: `banner-item card-type-${_vm.type}` }, [
              _c("iframe", {
                attrs: {
                  src: `${_vm.videoUrl}?rel=0&controls=0&showinfo=0`,
                  width: "100%",
                  frameborder: "0",
                  allow: "autoplay; encrypted-media",
                  allowfullscreen: "",
                },
              }),
            ]),
          ]
        : _vm.type == "wysiwyg"
        ? [
            _c("div", { class: `banner-item card-type-${_vm.type}` }, [
              _c("div", { domProps: { innerHTML: _vm._s(_vm.description) } }),
            ]),
          ]
        : _vm.type === "icon"
        ? [
            _c(
              "div",
              {
                class: [
                  `col-item card card-${_vm.type} card-text-${_vm.textAlign}`,
                  { "card-text-center": _vm.iconPosition === "center" },
                ],
                style: `background-color: ${_vm.backgroundColor}`,
              },
              [
                _c(
                  "div",
                  { staticClass: "card-content-body" },
                  [
                    _vm.iconPosition === "left"
                      ? [
                          _c("div", { staticClass: "icon-header" }, [
                            _c(
                              "div",
                              { staticClass: "icon-container" },
                              [
                                _c("AImage", {
                                  staticClass: "svg-icon",
                                  class: {
                                    "drop-shadow": _vm.iconDropShadow === true,
                                  },
                                  attrs: {
                                    img: _vm.item.fileStore,
                                    title: _vm.title,
                                    alt: _vm.title,
                                    responsive: "",
                                    preset: "carousel-image",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "title" }, [
                              _c("h3", { style: `color: ${_vm.textColor}` }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.title) +
                                    "\n              "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.description
                            ? _c(
                                "div",
                                {
                                  staticClass: "description",
                                  style: `color: ${_vm.textColor}`,
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.description) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.iconPosition === "leftcontent"
                      ? [
                          _c("div", { staticClass: "icon-container" }, [
                            _c("img", {
                              staticClass: "svg-icon",
                              class: {
                                "drop-shadow": _vm.iconDropShadow === true,
                              },
                              attrs: {
                                src: _vm.backgroundImageUrl,
                                alt: "Icon",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "icon-content" }, [
                            _c("div", { staticClass: "title" }, [
                              _c("h3", { style: `color: ${_vm.textColor}` }, [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.title) +
                                    "\n                "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _vm.description
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "description",
                                    style: `color: ${_vm.textColor}`,
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.description) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.iconPosition === "left"
                      ? [
                          _c(
                            "div",
                            { staticClass: "icon-container text-center" },
                            [
                              _c("img", {
                                staticClass: "svg-icon",
                                class: {
                                  "drop-shadow": _vm.iconDropShadow === true,
                                },
                                attrs: {
                                  src: _vm.backgroundImageUrl,
                                  alt: "Icon",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "title" }, [
                            _c("h3", { style: `color: ${_vm.textColor}` }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.title) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _vm.description
                            ? _c(
                                "div",
                                {
                                  staticClass: "description",
                                  style: `color: ${_vm.textColor}`,
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.description) +
                                      "\n        "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.buttonPrimaryExists && _vm.buttonSecondaryExists
                  ? [
                      _c("div", { staticClass: "card-content-footer" }, [
                        _vm.buttonPrimaryExists && _vm.buttonSecondaryExists
                          ? _c(
                              "div",
                              { staticClass: "card-actions" },
                              [
                                _vm.buttonPrimaryExists
                                  ? [
                                      _c(
                                        "generic-link",
                                        {
                                          staticClass: "btn btn-primary-cta",
                                          attrs: {
                                            target: _vm.primaryButtonTarget,
                                            href: _vm.buttonPrimaryUrl,
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.buttonPrimaryText)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.buttonSecondaryExists
                                  ? [
                                      _c(
                                        "generic-link",
                                        {
                                          staticClass: "btn btn-secondary-cta",
                                          attrs: {
                                            target: _vm.secondaryButtonTarget,
                                            href: _vm.buttonSecondaryUrl,
                                          },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(_vm.buttonSecondaryText)
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]),
                    ]
                  : _vm.buttonSecondaryUrl
                  ? [
                      _c("generic-link", {
                        staticClass: "card-overlay-link",
                        attrs: {
                          target: _vm.primaryButtonTarget,
                          href: _vm.buttonPrimaryUrl,
                        },
                      }),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }